import { Outlet } from 'react-router-dom'

import SidebarNav from '../components/sidebar-nav'

const SettingsLayout = () => {
  return (
    <div className="size-full overflow-hidden bg-white">
      <div className="flex size-full min-h-0">
        <aside className="h-full w-[340px] shrink-0 overflow-y-auto border-r border-lightBorder px-6 py-8">
          <SidebarNav />
        </aside>
        <main className="min-w-0 flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default SettingsLayout
